/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { CornLiquefacao } from "./modelCornLiquefacao";

class ControllerCornLiquefacao extends ControllerModel {
  constructor() {
    super("ControllerCornLiquefacao");
    
    this.setNewNode = (callback) => {
      let vasteurization = new CornLiquefacao();
      vasteurization.decorate(callback);

      this.addNode(vasteurization);
    }

    this.loadNode = (node, callback) => {
      let vasteurization = new CornLiquefacao();
      vasteurization.copyFrom(node);
      vasteurization.decorate(callback);
      this.addNode(vasteurization)
    }

    this.getProperties = async (node) => {
      let n = new CornLiquefacao();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new CornLiquefacao();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerCornLiquefacao };
